import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const addAdjustmentData = async (adjustmentData) => {
  try {
    const res = await API.add_ledger_adjustment(adjustmentData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdjustmentDetails = async (ID) => {
  try {
    const res = await API.adjustemnt_details(ID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};